/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Marquee = (props) => {
  const { getUpcomingEventQuery } = props;

  const cycling = "/media/assets/svg/directions-bike.svg";
  const walking = "/media/assets/svg/directions-walk.svg";
  const running = "/media/assets/svg/directions-run.svg";

  const handleButtonClick = (value) => {
    window.location.href = value;
  };

  return (
    <section className="ribbon sponsor-slider">
      <Container fluid>
        <div className="row">
          <div className="col-auto ps-0">
            <div className="marquee">
              <div className="marquee__content">
                {getUpcomingEventQuery?.data?.result?.map((items) => (
                  <Col
                    className="marquee-item"
                    onClick={() => {
                      handleButtonClick(items?.pageURL);
                    }}
                  >
                    <div className="marquee-image-container position-relative">
                      <img
                        src={
                          items?.webBannerImage
                            ? items?.webBannerImage
                            : "https://picsum.photos/450/300/?random"
                        }
                        alt=""
                        className="marquee-image  rounded-4"
                      />
                      <div className="marquee-overlay rounded-4">
                        <div
                          className="d-flex align-items-center position-absolute transparent-bg top-0 end-0 rounded-pill mx-3 my-3 p-1 border border-white gap-2"
                          style={{
                            fontWeight: "600",
                          }}
                        >
                          <img
                            src={
                              items?.eventTypeID === 1
                                ? cycling
                                : items?.eventTypeID === 2
                                ? walking
                                : items?.eventTypeID === 3
                                ? running
                                : ""
                            }
                            height={20}
                            width={20}
                          />
                          <p className="plus-jakarta-sans-font text-uppercase text text-dark my-0">
                            {items.eventTypeName
                              ? items.eventTypeName
                              : "CYCLING"}
                          </p>
                        </div>
                        <Row>
                          <Col className=" d-flex flex-column align-items-start position-absolute bottom-0 start-0 mx-2 my-4">
                            <h4 className="text-white plus-jakarta-sans-font">
                              {items.eventName
                                ? items.eventName
                                : "Run for change"}
                            </h4>
                            <div className="text-white fs-6 multi-line-text-truncate text-start plus-jakarta-sans-font">
                              {items.description
                                ? items.description
                                : "Lorem ipsum dolor sit amet consectetur. Morbi egestas imperdiet justo nulla."}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                ))}
              </div>
              <div className="marquee__content">
                {getUpcomingEventQuery?.data?.result?.map((items) => (
                  <Col
                    className="marquee-item"
                    onClick={() => {
                      handleButtonClick(items?.pageURL);
                    }}
                  >
                    <div className="marquee-image-container position-relative">
                      <img
                        src={
                          items?.webBannerImage
                            ? items?.webBannerImage
                            : "https://picsum.photos/450/300/?random"
                        }
                        alt=""
                        className="marquee-image  rounded-4"
                      />
                      <div className="marquee-overlay rounded-4">
                        <div
                          className="d-flex align-items-center position-absolute transparent-bg top-0 end-0 rounded-pill mx-3 my-3 p-1 border border-white gap-2"
                          style={{
                            fontWeight: "600",
                          }}
                        >
                          <img
                            src={
                              items?.eventTypeID === 1
                                ? cycling
                                : items?.eventTypeID === 2
                                ? walking
                                : items?.eventTypeID === 3
                                ? running
                                : ""
                            }
                            height={20}
                            width={20}
                          />
                          <p className="plus-jakarta-sans-font text-uppercase text text-dark my-0">
                            {items.eventTypeName
                              ? items.eventTypeName
                              : "CYCLING"}
                          </p>
                        </div>
                        <Row>
                          <Col className=" d-flex flex-column align-items-start position-absolute bottom-0 start-0 mx-2 my-4">
                            <h4 className="text-white plus-jakarta-sans-font">
                              {items.eventName
                                ? items.eventName
                                : "Run for change"}
                            </h4>
                            <div className="text-white fs-6 multi-line-text-truncate text-start plus-jakarta-sans-font">
                              {items.description
                                ? items.description
                                : "Lorem ipsum dolor sit amet consectetur. Morbi egestas imperdiet justo nulla."}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Marquee;
